import * as types from 'constants/action_types'
import * as pages from 'constants/pages'

const storage = require('../util/storage')

const defaultState = {
  direction: 'normal',
  targetTicketId: null,
  childTicketIds: null,
  mergeId: null,
}

const reducers = {}

reducers[types.SWAP_MERGE_DIRECTION] = (state, { data }) => {
  const { targetTicketId, childTicketIds, direction } = state

  return {
    ...state,
    targetTicketId: childTicketIds ? childTicketIds[0] : null,
    childTicketIds: targetTicketId ? [targetTicketId] : null,
    direction: direction === 'normal' ? 'swapped' : 'normal',
  }
}

reducers[types.TICKETS_SELECTED_FOR_MERGE] = (state, { data }) => {
  const { childTicketIds, mergeId } = data
  const { direction } = state

  if (direction === 'normal') {
    // HACK (jscheel): Reorders child ticket ids so that they match
    // the way that API sorts child ticket ids before merging. This
    // will ensure optimistic data matches.
    const sortedChildTicketIds = childTicketIds.slice().sort((a, b) => {
      if (parseInt(a, 10) < parseInt(b, 10)) return -1
      if (parseInt(a, 10) > parseInt(b, 10)) return 1
      return 0
    })

    return {
      ...state,
      childTicketIds: sortedChildTicketIds,
      mergeId,
    }
  }

  // else, swapped direction
  return {
    ...state,
    targetTicketId: childTicketIds[0],
    mergeId,
  }
}

reducers[types.CANCEL_MERGE] = state => {
  const { direction } = state
  if (direction === 'normal') {
    return {
      ...state,
      childTicketIds: null,
      mergeId: null,
    }
  }

  return {
    ...state,
    targetTicketId: null,
    mergeId: null,
  }
}

reducers[pages.TICKET_MERGE_PAGE] = (state, { payload }) => {
  const { id } = payload

  return {
    ...defaultState,
    targetTicketId: id,
  }
}

export default function reducer(state = defaultState, action) {
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
